import _compact from 'lodash/compact';
import { RichTextNode } from 'pages/Homepage/typings';

function getCount(children: Array<RichTextNode>) {
  const textItems: Array<string> = [];

  function getRichTextCharCount(children: Array<RichTextNode>) {
    children.forEach(c => {
      if (!c.children) {
        // @ts-ignore
        textItems.push(c.text);
      } else if (c.children.length > 1) {
        getRichTextCharCount(c.children);
      } else if (c.children[0].children) {
        getRichTextCharCount(c.children[0].children);
      } else {
        // @ts-ignore
        textItems.push(c.children[0].text);
      }
    });
  }

  getRichTextCharCount(children);

  return _compact(textItems).reduce((acc, item) => {
    acc = acc + item.length;

    return acc;
  }, 0);
}

export default getCount;
